import { api } from '@/boot/axios'

/**
 * Authenticated endpoints
 */
export async function getConfig() {
  const { data } = await api.get('/intake/config')
  return data
}

export async function updateConfig(payload) {
  const { data } = await api.put('/intake/config', payload)
  return data
}

export async function getSubmissions(params = {}) {
  const { data } = await api.get('/intake/submissions', { params })
  return data
}

export async function exportSubmissions(params = {}) {
  const { data } = await api.get('/intake/submissions', {
    params: { ...params, export: 'csv' },
    responseType: 'blob'
  })
  return data
}

export async function searchProducts(query, { limit = 25 } = {}) {
  const { data } = await api.get('/intake/products/search', {
    params: { query, limit }
  })
  return data
}

export async function getSubmission(id) {
  const { data } = await api.get(`/intake/submissions/${id}`)
  return data
}

export async function updateSubmission(id, payload) {
  const { data } = await api.patch(`/intake/submissions/${id}`, payload)
  return data
}

export async function convertSubmission(id) {
  const { data } = await api.post(`/intake/submissions/${id}/convert`)
  return data
}
